<template>
  <v-row>
    <v-col cols="4">
      <payfast-transitioned-subscriptions />
    </v-col>
    <v-col cols="4">
      <chats-inactive-staff />
    </v-col>
    <v-col cols="4">
      <clients-without-support-owner />
    </v-col>
  </v-row>
</template>

<script>
import PayfastTransitionedSubscriptions from "@/components/reporting/blocks/PayfastTransitionedSubscriptions";
import ChatsInactiveStaff from "@/components/reporting/blocks/ChatsInactiveStaff";
import ClientsWithoutSupportOwner from "@/components/reporting/blocks/ClientsWithoutSupportOwner";

export default {
  name: "OperationsDashboard",
  components: { PayfastTransitionedSubscriptions, ChatsInactiveStaff, ClientsWithoutSupportOwner },
  data() {
    return {};
  },
};
</script>
